import NewNotificationBell from "../../assets/svg/NewNotificationBell.svg";
import NewNotificationBellDot from "../../assets/svg/NewNotificationBellDot.svg";
import CrossSvg from "../../assets/svg/CrossIcon.svg";
import { useEffect, useState } from "react";
import { useUser } from "@/hooks/useUser";
import useAllNotificationQuery, {
  NotificationType,
} from "@/api/query/useAllNotificationQuery";
import { io } from "socket.io-client";
import { baseURL } from "@/Environment";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { CheckCheck } from "lucide-react";
import { toast } from "react-toastify";
import useSingleReadNotificationMutation from "@/api/mutation/useSingleReadNotificationMutation";
import timeAgo from "@/helperFuntions/notificationFormatter";
import Dialog from "../common/Dialog";
import useReadAllNotificationMutation from "@/api/mutation/useReadAllNotificationMutation";
import useProjectQuery from "@/api/query/useProjectQuery";
import UserAvatar from "../ui/userAvatar";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { SideBarNewProps } from "./SidebarNew";
import HamburgerIcon from "@/assets/svg/Hamburger.svg";
import { errorConfig } from "@/lib/toastError";
import UserIcon from "@/assets/svg/Users.svg";
import crossNew from "@/assets/svg/crossNew.svg";
import NewLogout from "../../assets/svg/NewLogout.svg";
// import EnFlag from "../../assets/svg/En.svg";
// import FrFlag from "../../assets/svg/Fr.svg";
import NewMessageQuestion from "../../assets/svg/NewMessageQuestion.svg";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import MySubscription from "@/assets/svg/subscreption.svg";
// import PaymentPlans from "../PaymentPlans";
import usePaymentStatusQuery from "@/api/query/usePaymentStatusQuery";
import GreenChackMark from "@/assets/svg/GreenChackMark.svg";
import RedCharmTick from "@/assets/svg/RedCharmTick.svg";
import PhoneTelephone from "@/assets/svg/PhoneTelephone.svg";
import Spinner from "../ui/spinner";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import {
  ExtendPlanTypeEnumSchema,
  PlanTypeEnumSchema,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import BackIcon from "@/assets/svg/NewLetsIconsBack.svg";
import useUserProfileUpdateMutation from "@/api/mutation/useUserProfileUpdateMutation";

export const NavbarNew = (props: SideBarNewProps) => {
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState<NotificationType[]>([]);
  const [isOpenPopUpRead, setisOpenPopUpRead] = useState(false);
  const useAllNotification = useAllNotificationQuery();
  const { user } = useUser();
  const useReadAllNotification = useReadAllNotificationMutation();
  const projectQuery = useProjectQuery();
  const { projectId, id, organisationId } = useParams();
  const [projectName, setprojectName] = useState<string>();
  const navigate = useNavigate();
  const urlLocation = window.location.pathname.split("/")[1];
  const { logout } = useAuth();
  const [isShowVideo, setIsShowVideo] = useState(false);
  const location = useLocation();
  // const [openMySubscriptions, setOpenMySubscriptions] = useState(false);
  const [isPaymentSuccess, setIsPaymentSuccess] = useState<{
    loading: boolean;
    status: "PENDING" | "SUCCESS" | "ERROR";
  }>({
    loading: false,
    status: "PENDING",
  });
  useEffect(() => {
    const project = projectQuery.data?.data.data.find(
      (project) => project.projectId == (projectId ?? id)
    )?.projectName;
    setprojectName(project);
  }, [projectId, id, projectQuery.data?.data.data, urlLocation]);

  const [filter, setFilter] = useSearchParams();
  const paymentStatus = usePaymentStatusQuery(filter.get("session_id") ?? "");
  const userQuary = useCurrentUserQuery();
  const [isShowRiskVideo, setIsShowRiskVideo] = useState(false);
  const [roadmapVideo, setRoadmapVideo] = useState(false);

  useEffect(() => {
    if (
      user &&
      user.subscription?.customerId === ExtendPlanTypeEnumSchema.FREE_TRIAL
    ) {
      const start = new Date(user.subscription.startDate);
      const today = new Date();

      // Normalize both to midnight (optional but avoids timezone issues)
      start.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const diffMs = today.getTime() - start.getTime();
      const passedDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      const totalTrialDays = 14; // or 1 for testing
      // const totalTrialDays = 1; // or 1 for testing
      const remainingDays = Math.max(totalTrialDays - passedDays, 0);

      if (remainingDays <= 3 && remainingDays > 0) {
        toast.success(
          <div className="flex items-center">
            <p className="text-wrap">
              {t("last_few_days_message", { daysLeft: remainingDays })} &nbsp;
            </p>
            <div className="">
              <button
                onClick={() =>
                  window.open("https://calendly.com/projectchef/45min")
                }
                className="border-b border-b-white outline-none mt-1 ml-auto"
              >
                {t("discuss")}
              </button>
            </div>
          </div>,
          { toastId: "user_info", autoClose: false }
        );
      }
    }
  }, [user]);

  useEffect(() => {
    if (filter.get("session_id")) {
      setIsPaymentSuccess({ loading: true, status: "PENDING" });
      paymentStatus.refetch().then((res: any) => {
        if (res?.data?.data?.data?.status === "complete") {
          setIsPaymentSuccess({ loading: true, status: "SUCCESS" });
          userQuary.refetch();
          toast.error(`${t("user_alert_message")}`, { toastId: "user_alert", autoClose: false });
        } else {
          setIsPaymentSuccess({ loading: true, status: "ERROR" });
        }
      });
    }
    if (filter.get("organization")) {
      navigate("/organisation/" + user?.userOrganisation[0].organisationId, {
        state: { tab: 3 },
      });
    }
  }, [location, filter]);

  useEffect(() => {
    if (window.location.pathname == "/projects") {
      if (
        !user?.isTutorialShow &&
        user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR
      ) {
        setIsShowVideo(true);
      }
    }
  }, [user, location]);

  useEffect(() => {
    setNotifications(useAllNotification.data?.data.data ?? []);
    const socket = io(baseURL, {
      path: "/socket.io",
      forceNew: true,
      reconnectionAttempts: 3,
      timeout: 2000,
      query: {
        roomName: user?.userId,
      },
    });
    socket.emit("join", user?.userId);
    socket.on("notification", (notificationObject) => {
      if (notificationObject) {
        const notificationSort = [
          ...(useAllNotification.data?.data.data ?? []),
          {
            notificationId: notificationObject.notificationId,
            type: notificationObject.type,
            referenceId: notificationObject.referenceId,
            sentBy: notificationObject.sentBy,
            sentTo: notificationObject.sentTo,
            details: notificationObject.details,
            isRead: notificationObject.isRead,
            createdAt: notificationObject.createdAt,
            ReadAt: notificationObject.ReadAt,
            sentNotificationBy: notificationObject.sentNotificationBy,
            sentNotificationTo: notificationObject.sentNotificationTo,
            task: notificationObject.task,
          },
        ].sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setNotifications(notificationSort);
      }
    });
    socket.on("logout", (logout) => {
      if (logout) {
        toast.error(
          <div className="lg:flex gap-1 items-center">
            <p className=" text-wrap">
              {t(
                "We have released a new version. Please log out and log in to see the latest version."
              )}
              <br />
            </p>
            <div className="flex justify-end items-center">
              <button
                onClick={() => window.location.reload()}
                className="border-b border-b-white outline-none mt-1 text-xs"
              >
                {t("reload")}
              </button>
            </div>
          </div>,
          { autoClose: false }
        );
      }
    });

    return () => {
      socket.off("notification");
      socket.off("logout");
    };
  }, [useAllNotification.data?.data.data]);

  const handleReadAll = () => {
    const updatedNotifications = notifications?.map((notification) => ({
      ...notification,
      isRead: true,
    }));

    if (updatedNotifications) {
      useReadAllNotification.mutate(
        updatedNotifications as unknown as NotificationType,
        {
          onSuccess(data) {
            toast.success(data.data.message);
            setNotifications([]);
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          },
        }
      );
    }
  };

  const singleReadNotificationMutation = useSingleReadNotificationMutation();

  const handleSingleReadNotification = (notificationData: NotificationType) => {
    singleReadNotificationMutation.mutate(
      { ...notificationData, isRead: true },
      {
        onSuccess: (data) => {
          toast.success(data.data.message);
          setNotifications((prevNotifications) => {
            if (prevNotifications) {
              return prevNotifications.filter(
                (n) => n.notificationId !== notificationData.notificationId
              );
            }
            return prevNotifications;
          });
        },
        onError: (error) => {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };
  const [isMobailView, setIsMobailView] = useState(false);
  useEffect(() => {
    // setIsMobailView(window.outerWidth < 768);
    setIsMobailView(false);
  }, []);

  const [confirmDashboard, setConfirmDashboard] = useState(false);
  useEffect(() => {
    if(user?.subscription?.customerId === ExtendPlanTypeEnumSchema.FREE_TRIAL) {
      setConfirmDashboard(false);
      return;
    } else if (
      (urlLocation == "projectDashboard" ||
        urlLocation == "" ||
         urlLocation == "capacity-planning" ||
        urlLocation == "risk" || urlLocation == "workload") &&
      (user?.subscription?.planType == PlanTypeEnumSchema.FREE ||
        !user?.subscription)
    ) {
      setConfirmDashboard(true);
    } else {
      setConfirmDashboard(false);
    }
  }, [location.pathname, user, urlLocation]);

  const userProfileUpdateMutation = useUserProfileUpdateMutation();
  const currentUserQuery = useCurrentUserQuery();
  const setIsTutorialShow = () => {
   
    userProfileUpdateMutation.mutate(
       {
         isTutorialShow: true,
         firstName: user?.firstName || "",
         lastName:  user?.lastName || "",
         email: user?.email || "",
       },
      {
        onSettled() {
          currentUserQuery.refetch();
        },
      }
    );
  };

  
    useEffect(() => {
      const handleFullscreenChange = () => {
        const navbar = document.getElementById("navbar");
        const sidebar = document.getElementById("Sidebar");
  
        if (document.fullscreenElement) {
          if (navbar) navbar.classList.add("!hidden");
          if (sidebar) sidebar.classList.add("!hidden");
        } else {
          if (navbar) navbar.classList.remove("!hidden");
          if (sidebar) sidebar.classList.remove("!hidden");
        }
      };
  
      document.addEventListener("fullscreenchange", handleFullscreenChange);
  
      return () => {
        document.removeEventListener("fullscreenchange", handleFullscreenChange);
      };
    }, []);

  return (
    <>
      <div
        className="flex justify-between items-center w-full z-20 shadow-md p-2 bg-white  gap-2"
        id="navbar"
      >
        {isMobailView && (
          <div onClick={() => props.setOpen(true)}>
            <img src={HamburgerIcon} className="h-4 w-4" />
          </div>
        )}
        <div
          className={`text-lg lg:text-2xl font-bold flex justify-between items-center w-full truncate h-fit text-gray-800 ${
            projectQuery.data?.data.data.find(
              (item) => item.organisationId === organisationId
            ) && "font-semibold"
          }`}
        >
          {projectName ? (
            <div className="flex text-sm text-gray-450 font-normal ml-5 gap-2 ">
              {t("projects")} /{" "}
              <p className="text-primary-500 ml-1 w-40 truncate ">
                {projectName}
              </p>
            </div>
          ) : (
            projectQuery.data?.data.data.find(
              (item) => item.organisationId === organisationId
            ) && t("organisation_settings")
          )}

          {projectQuery.data?.data.data?.length == 0 &&
            urlLocation == "projects" && (
              <div className="flex items-center w-full">
                <div>👋</div>
                <div>
                  <div className="text-[#0D062D] text-xl">
                    {t("welcome_to_projectchef")}
                  </div>
                  <div className="text-sm text-gray-450 truncate w-fit">
                    {t("please_follow_the_steps_to_get_started")}
                  </div>
                </div>
              </div>
            )}
          {urlLocation == "mytasks" && t("mytask")}
          {urlLocation == "checkout" && t("checkout")}
          {urlLocation == "projects" &&
            projectQuery.data &&
            projectQuery.data?.data.data?.length > 0 &&
            t("project_list")}
          {urlLocation == "" && t("portfolio_dashboard")}
          {urlLocation == "organisation" && !organisationId && (
            <div className="flex items-center">
              <div>👋</div>
              <div>
                <div className="text-[#0D062D] text-xl">
                  {t("welcome_to_projectchef")}
                </div>
                <div className="text-sm text-gray-450 truncate w-[">
                  {t("please_follow_the_steps_to_get_started")}
                </div>
              </div>
            </div>
          )}
          {window.location.pathname.includes("scales") && (
            <div className="text-base flex gap-5 items-center">
              <img
                src={BackIcon}
                className="h-6 cursor-pointer min-h-6 ml-3"
                onClick={() => window.history.back()}
              />
              {t("Impact and Probability Scales")}
            </div>
          )}
        </div>

        <div className="right flex gap-2 items-center ">
          <div className="flex gap-2 items-center">
            {(user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.ADMINISTRATOR ||
              projectQuery.data?.data.data.some((item) =>
                item.assignedUsers.find(
                  (u) =>
                    u.user.userId == user?.userId &&
                    u.projectRole == UserRoleEnumValue.PROJECT_MANAGER
                )
              )) && (
              <Button
                variant={"primary"}
                className="!truncate"
                onClick={() =>
                  window.open(
                    "https://calendly.com/projectchef/45min",
                    "_blank"
                  )
                }
              >
                <img src={PhoneTelephone} className="mr-0.5 h-4 w-4 invert" />
                {t("Book an onboarding call")}
              </Button>
            )}
            <DropdownMenu>
              <DropdownMenuTrigger className="px-2.5 py-1 rounded-md border border-gray-300/50">
                {t("help")}
              </DropdownMenuTrigger>
              <DropdownMenuContent className="!overflow-y-auto !max-h-[600px] !w-64">
                <DropdownMenuItem className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() => setIsShowVideo(true)}
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("Presentation")}
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() => setIsShowRiskVideo(true)}
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("Risk Management")}
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() => setRoadmapVideo(true)}
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("rode_map")}
                  </Button>
                </DropdownMenuItem>
                <DropdownMenuItem className="p-0">
                  <Button
                    variant={"none"}
                    onClick={() =>
                      window.open(
                        "https://projectchef.io/contact-us/",
                        "_blank"
                      )
                    }
                    className="text-primary-500 underline w-full !justify-start"
                  >
                    {t("Contact us")}
                  </Button>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
          <div className=" ">
            <a
              className="text-primary-500 text-sm underline flex items-center gap-0.5 pointer text-nowrap"
              target="_blank"
              href="https://projectchef.io/user-voice/"
            >
              <img
                src={NewMessageQuestion}
                className="min-w-7 align-middle rounded-full"
                alt="No Image Found"
              />
              {t("share_your_feedback")}
            </a>
          </div>
          <div className="notification">
            {!isOpenPopUpRead && (
              <div className="relative">
                <DropdownMenu>
                  <DropdownMenuTrigger>
                    <Button className="w-8 h-8 aspect-square rounded-full bg-transparent active:bg-primary-100 hover:bg-primary-100  cursor-pointer">
                      <img
                        src={
                          notifications?.length > 1
                            ? NewNotificationBellDot
                            : NewNotificationBell
                        }
                        className="absolute top-1 left-1"
                      />
                      {notifications && notifications.length > 0 && (
                        <div className="w-6 h-6 rounded-full bg-red-700 absolute bottom-5 left-5 text-xs p-2 flex justify-center items-center text-white">
                          {notifications.length <= 99
                            ? notifications.length
                            : "99+"}
                        </div>
                      )}
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="!overflow-y-auto !max-h-[600px] !w-64">
                    <div className="flex justify-between">
                      <div>
                        <DropdownMenuLabel className="!font-bold">
                          {t("notifications")}
                        </DropdownMenuLabel>
                      </div>

                      {notifications && notifications.length > 0 && (
                        <CheckCheck
                          onClick={() => setisOpenPopUpRead(true)}
                          className="flex justify-center items-center"
                        />
                      )}
                    </div>
                    <DropdownMenuSeparator />
                    {notifications && notifications.length > 0 ? (
                      notifications.map((notification) => (
                        <>
                          <DropdownMenuItem key={notification.notificationId}>
                            <div className="w-full">
                              <div className="flex justify-between w-full items-center">
                                <div className="flex gap-2 w-full items-center">
                                  <div className="mb-4">
                                    {/* <img src={notification.sentNotificationTo.avatarImg} className="rounded-[50%]" width={'30px'}/> */}
                                    <UserAvatar
                                      user={notification.sentNotificationBy}
                                      className="w-6 h-6"
                                    />
                                  </div>
                                  <div className="flex flex-col gap-0.5">
                                    <div className="text-md font-semibold break-all">
                                      {notification.details}
                                    </div>
                                    <div className="text-gray-300 ">
                                      {timeAgo(
                                        new Date(notification.createdAt)
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="cursor-pointer mb-4"
                                  onClick={() =>
                                    handleSingleReadNotification(notification)
                                  }
                                >
                                  <img
                                    src={CrossSvg}
                                    height={"20px"}
                                    width={"15px"}
                                  />
                                </div>
                              </div>
                            </div>
                          </DropdownMenuItem>
                          <DropdownMenuSeparator />
                        </>
                      ))
                    ) : (
                      <div className="p-2">{t("no_notification_found")}</div>
                    )}
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            )}
            {isOpenPopUpRead && (
              <Dialog
                isOpen={isOpenPopUpRead}
                onClose={() => {}}
                modalClass="rounded-lg"
              >
                <div className="flex flex-col gap-2 p-6 ">
                  {t("read_all_notifications")}
                  <div className="flex gap-2 ml-auto">
                    <Button
                      variant={"outline"}
                      isLoading={useReadAllNotification.isPending}
                      disabled={useReadAllNotification.isPending}
                      onClick={() => setisOpenPopUpRead(false)}
                    >
                      {t("cancel")}
                    </Button>
                    <Button
                      variant={"primary"}
                      onClick={() => {
                        handleReadAll();
                        setisOpenPopUpRead(false);
                      }}
                      isLoading={useReadAllNotification.isPending}
                      disabled={useReadAllNotification.isPending}
                    >
                      {t("yes")}
                    </Button>
                  </div>
                </div>
              </Dialog>
            )}
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild className="pr-8">
              <div
                className={`profileDetails flex items-center gap-2 cursor-pointer ${
                  notifications.length > 0 ? "ml-1.5" : "ml-0"
                }`}
              >
                <div className="rounded-full border p-0.5">
                  <UserAvatar user={user} />
                </div>
                {!isMobailView && (
                  <div className="flex flex-col items-start">
                    <div className="text-base text-[#0D062D] font-medium">
                      {user?.firstName}
                    </div>
                    {/* <div className="text-sm text-gray-450">
                      {countries.find((d) => d.isoCode == user?.country)?.name}
                    </div> */}
                  </div>
                )}
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-auto">
              <DropdownMenuItem className="disabled:cursor-not-allowed" disabled={ Boolean(!user?.userOrganisation[0])}>
                <Button
                  variant={"none"}
                  className="flex w-full justify-start p-0 h-fit"
                  onClick={() => navigate("/account-settings")}
                >
                  <img src={UserIcon} className="mr-0.5 h-4 w-4" />
                  {t("portfolio_details")}
                </Button>
              </DropdownMenuItem>
              <hr className="w-full h-px" />
              {user?.userOrganisation[0]?.role &&
                user?.userOrganisation[0]?.role ==
                  UserRoleEnumValue.ADMINISTRATOR && (
                  <DropdownMenuItem onClick={() => navigate("/plans")}>
                    <img
                      src={MySubscription}
                      className=" h-5 w-5 text-[#44546F]"
                    />
                    <Button
                      className="p-0 font-normal h-auto"
                      variant={"ghost"}
                    >
                      {t("MySubscriptions")}
                    </Button>
                  </DropdownMenuItem>
                )}
              <hr className="w-full h-px" />

              <DropdownMenuItem>
                <button
                  type="button"
                  className="flex w-full justify-start"
                  onClick={logout}
                >
                  <div className="md:w-3.5 md:h-3.5 xl:w-5 xl:h-5">
                    <img
                      className="align-middle invert opacity-60 mr-0.5 h-4 w-4"
                      src={NewLogout}
                      alt="No Image Found"
                    />
                  </div>
                  {t("logout")}
                </button>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      {/* <Dialog
        isOpen={openMySubscriptions}
        onClose={() => {
          setOpenMySubscriptions(false);
        }}
        modalClass="rounded-lg px-5"
      >
        <PaymentPlans
          onClose={() => {
            setOpenMySubscriptions(false);
          }}
        />
      </Dialog> */}
      <Dialog
        isOpen={isPaymentSuccess.loading}
        onClose={() => {
          // setOpenMySubscriptions(false);
        }}
        modalClass="rounded-lg "
      >
        <div className=" w-80 h-fit flex flex-col gap-6 p-8 relative">
          {isPaymentSuccess.status == "ERROR" && (
            <div
              className="flex justify-end cursor-pointer items-center w-full h-1/4"
              onClick={() => {
                setIsPaymentSuccess({ loading: false, status: "PENDING" });
              }}
            >
              <img src={crossNew} className="w-4 max-w-4" />
            </div>
          )}
          <div className="flex justify-center  w-full h-3/4   items-center">
            {isPaymentSuccess.status === "SUCCESS" ? (
              <div className="flex justify-center items-center animate-fadeInScale rounded-full w-fit h-fit p-4 bg-green-500/50">
                <img src={GreenChackMark} className="w-20 h-20" />
              </div>
            ) : isPaymentSuccess.status == "PENDING" ? (
              <Spinner color="#299d91" className="h-20 w-20" />
            ) : (
              <div className="flex justify-center items-center animate-fadeInScale rounded-full w-fit h-fit p-4 bg-red-500/50">
                <img src={RedCharmTick} className="w-20 h-20" />
              </div>
            )}
          </div>
          <div className="text-center text-xl font-semibold">
            {isPaymentSuccess.status === "SUCCESS"
              ? t("Payment Success")
              : isPaymentSuccess.status == "PENDING"
              ? t("Payment is in progress")
              : "Payment Failed"}
            <div className="text-center text-sm text-gray-450">
              {isPaymentSuccess.status === "SUCCESS" ? (
                <div className="flex flex-col gap-2">
                  <p>{t("Your subscription is active now")}</p>
                  <Button
                    onClick={() => {
                      setIsPaymentSuccess({
                        loading: false,
                        status: "PENDING",
                      });
                      // setOpenMySubscriptions(false);
                      projectQuery.refetch();
                      setFilter({});
                    }}
                    variant={"primary"}
                  >
                    {t("Ok")}
                  </Button>
                </div>
              ) : isPaymentSuccess.status == "PENDING" ? (
                t("Please wait while we process your payment")
              ) : (
                <div className="flex flex-col gap-2">
                  <p>{t("Please try again")}</p>
                  <Button
                    onClick={() => {
                      setIsPaymentSuccess({
                        loading: false,
                        status: "PENDING",
                      });
                      // setOpenMySubscriptions(true);
                      navigate("/plans");
                      setFilter({});
                    }}
                    variant={"primary"}
                  >
                    {t("Try again")}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={confirmDashboard}
        onClose={() => {}}
        modalClass="rounded-lg "
        bgClass="!backdrop-blur-sm z-50"
      >
        <div className="flex flex-col gap-4 p-6 w-96 text-center ">
          {(!user?.userOrganisation[0]?.role ||
            user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.COLLABORATOR) &&
            t(
              "You do not have access to this dashboard with your current plan. Please contact your administrator to upgrade the current plan"
            )}
          {user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR &&
            t(
              urlLocation == ""
                ? "Portfolio dashboard are not available in this plan. Do you want to upgrade your plan?"
                : urlLocation == "risk"
                ? "Risk management module is not available in this plan. Do you want to upgrade your plan?"
                : urlLocation == "capacity-planning"
                ? "Capacity Planning"
                : urlLocation == "workload"
                ? "Workload module is not available in this plan. Do you want to upgrade your plan?"
                : "Project dashboard are not available in this plan. Do you want to upgrade your plan?"
            )}
          <div className="flex gap-2 ml-auto">
            {!user?.userOrganisation[0]?.role ||
            user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.COLLABORATOR ? (
              <Button
                variant={"outline"}
                onClick={() => {
                  setConfirmDashboard(false), navigate("/projects");
                }}
              >
                {t("ok")}
              </Button>
            ) : (
              <>
                <Button
                  variant={"outline"}
                  onClick={() => {
                    setConfirmDashboard(false), navigate("/projects");
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant={"primary"}
                  // onClick={removeTask}.
                  className={"text-white"}
                  onClick={() => {
                    navigate("/plans");
                  }}
                >
                  {t("Upgrade")}
                </Button>
              </>
            )}
          </div>
        </div>
      </Dialog>
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => {}}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30">
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer close"
              onClick={() => {
                setIsShowVideo(false), setIsTutorialShow();
              }}
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/998692707?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
      {isShowRiskVideo && (
        <Dialog
          isOpen={isShowRiskVideo}
          onClose={() => {}}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative "
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30 close"
            onClick={() => setIsShowRiskVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1054493760?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
      {roadmapVideo && (
        <Dialog
          isOpen={roadmapVideo}
          onClose={() => {}}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative "
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30 close"
            onClick={() => setRoadmapVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1083552233?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
    </>
  );
};
